import { values } from 'lodash';
import { CALL_API, HTTP_METHODS } from '../middlewares/api.js';
import { projectOwner as projectOwnerSchema } from '../lib/schema.js';
import { selectCurrentOrganizationId } from './auth.js';

const RETRIEVE_PROJECT_OWNERS_REQUEST =
  'changesync/projectOwners/RETRIEVE_PROJECT_OWNERS_REQUEST';
const RETRIEVE_PROJECT_OWNERS_SUCCESS =
  'changesync/projectOwners/RETRIEVE_PROJECT_OWNERS_SUCCESS';
const RETRIEVE_PROJECT_OWNERS_FAILURE =
  'changesync/projectOwners/RETRIEVE_PROJECT_OWNERS_FAILURE';

const initialState = {
  retrieveProjectOwners: {
    pending: false,
    success: false,
    error: null,
  },
};

// Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case RETRIEVE_PROJECT_OWNERS_REQUEST:
      return {
        ...state,
        retrieveProjectOwners: {
          ...state.retrieveProjectOwners,
          pending: true,
          success: false,
          error: null,
        },
      };

    case RETRIEVE_PROJECT_OWNERS_SUCCESS:
      return {
        ...state,
        retrieveProjectOwners: {
          ...state.retrieveProjectOwners,
          pending: false,
          success: true,
        },
      };
    case RETRIEVE_PROJECT_OWNERS_FAILURE:
      return {
        ...state,
        retrieveProjectOwners: {
          ...state.retrieveProjectOwners,
          pending: false,
          error: action.error,
        },
      };
    default:
      return state;
  }
};

// Action Creators

export const retrieveProjectOwners = (query) => (dispatch, getState) => {
  const organizationId = selectCurrentOrganizationId(getState());

  return dispatch({
    [CALL_API]: {
      types: [
        RETRIEVE_PROJECT_OWNERS_REQUEST,
        RETRIEVE_PROJECT_OWNERS_SUCCESS,
        RETRIEVE_PROJECT_OWNERS_FAILURE,
      ],
      endpoint: `organizations/${organizationId}/project_owners`,
      method: HTTP_METHODS.GET,
      schema: [projectOwnerSchema],
      query,
    },
  });
};

// Only active ("archived: false || null") owners by default
export const selectProjectOwners = (state) =>
  values(state.entities.projectOwners).filter((owner) => !owner.archived);

export const selectProjectOwnersWithArchived = (state) =>
  values(state.entities.projectOwners);

// export const selectProjectOwners = (state) => values(state.entities.projectOwners);
